function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Object, delayRemove, placement) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-drawer-stage': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`open`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "hook": {
              insert: $helpers.handleDrawerInsert,
              destroy: $helpers.handleDrawerDestroy,
            },
            "class": Object.assign({}, {
              delayed: {
                'mp-drawer-in': true
              },
              remove: {
                'mp-drawer-out': true,
                delayRemove
              },
              [`mp-drawer-placement-${placement}`]: true,
              'mp-drawer-not-fullscreen': $attr(`not-fullscreen`),
            }, {
              'mp-drawer': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.close
              },
              "class": {
                'mp-drawer-overlay': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-drawer-bg': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-drawer-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("slot"));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "delayRemove" in locals ? locals.delayRemove : typeof delayRemove !== "undefined" ? delayRemove : undefined, "placement" in locals ? locals.placement : typeof placement !== "undefined" ? placement : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;